import { URL_CURRENT_PLACEHOLDER, URL_STAFF_PREFIX } from "@oysterhr/router"
import {
  ASPECT_SEARCH_PARAM,
  CompositeIdPrefixForNamespace,
  NAMESPACES,
  STORED_ASPECT,
} from "./constants"
import { AccountAspectType } from "./enums"

export const getUrlAspectId = (url: URL) => {
  const namespace = NAMESPACES.find(namespace => url.pathname.startsWith(`/${namespace}`))
  const aspectSearchParam = url.searchParams.get(ASPECT_SEARCH_PARAM)

  if (!namespace || aspectSearchParam) {
    return aspectSearchParam || ""
  }

  if (namespace === URL_STAFF_PREFIX) {
    return `${AccountAspectType.STAFF}`
  }

  const urlArray = url.pathname.split("/")
  const idIndex = urlArray.indexOf(namespace) + 1

  return `${CompositeIdPrefixForNamespace[namespace]}:${urlArray[idIndex]}`
}

const inferCurrentAspectId = ({
  urlAspectId,
  availableAspectsIds,
}: {
  urlAspectId: string
  availableAspectsIds: string[]
}) => {
  const storedAspectId = window.localStorage.getItem(STORED_ASPECT) || ""
  const aspectType = urlAspectId.split(":")[0]

  if (storedAspectId.startsWith(aspectType)) {
    return availableAspectsIds.find(item => item === storedAspectId)
  }

  return availableAspectsIds.find(id => id.startsWith(aspectType))
}

export const getCurrentAspectId = ({
  urlAspectId,
  availableAspectsIds,
}: {
  urlAspectId: string
  availableAspectsIds: string[]
}) => {
  if (!urlAspectId) return undefined

  if (urlAspectId.includes(URL_CURRENT_PLACEHOLDER)) {
    return inferCurrentAspectId({
      urlAspectId,
      availableAspectsIds,
    })
  }

  return availableAspectsIds.find(id => id.toLowerCase().includes(urlAspectId.toLowerCase()))
}
